/* eslint-disable react/no-danger */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable no-console */

import React, { useContext, useState } from 'react';
import { Modal, IconButton, Box, Typography, Tooltip } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { Close, Done } from '@mui/icons-material';
import { LanguageContext } from '../../libs/Context';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { LoginContext } from '../../App';
import languageData from '../../locale/lan.json';
import { getObjectWithLanguage } from '../../libs/HelperContent';

const style = {
	position     : 'absolute',
	top          : 'var(--percent50)',
	left         : 'var(--percent50)',
	transform    : 'translate(-50%, -50%)',
	width        : '20rem',
	bgcolor      : 'background.paper',
	boxShadow    : 24,
	textAlign    : 'center',
	borderRadius : 'var(--pixel12)'
};

const Data = [
	{ id: 'en', label: 'English' },
	{ id: 'hi', label: 'Hindi - हिन्दी' },
	{ id: 'fr', label: 'Français' },
	{ id: 'it', label: 'Italiana' },
	{ id: 'pt', label: 'Português' },
	{ id: 'sp', label: 'Español' }
];

const LoginHeader = () =>
{
	// const pathName = window.location.pathname.split('/')[1];
	const { setLanguage, localeData, language, setLocaleData } = useContext(LanguageContext);
	const { cmpnyImgurl } = useContext(LoginContext);
	const [ open, setOpen ] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const langselect = (id:any) =>
	{
		localStorage.setItem('user_language', id);
		setLocaleData(id);
		setLanguage(getObjectWithLanguage(id));
		handleClose();
	};

	const languageD: any = Data.find((each: any) => each?.id === localeData);
	const defaultInLynkLogo = '/images/logos/In_logo.svg';

	return (

		<div className='flexRow alignCntr loginheader positionRelative authFormCntr'>

			<div className=' flexRow alignCntr authLogo'>
				{(cmpnyImgurl?.isLogoEnabled || cmpnyImgurl?.isTitleEnabled)
					? (
						<>
							{cmpnyImgurl?.isLogoEnabled && (
								<img src={cmpnyImgurl?.logoImage || cmpnyImgurl?.logoThumbnailImage}
									alt='inLynk-logo' height='32' width='120'
								/>
							)}
							{cmpnyImgurl?.isTitleEnabled && (
								<span>
									{cmpnyImgurl?.logoTitle
										? <div className='flexInline alignCntr pdngLXXS' dangerouslySetInnerHTML={{ __html: cmpnyImgurl.logoTitle }} />
										: (cmpnyImgurl?.isLogoEnabled === false ? <img src='/images/logos/In_logo.svg' alt='Logo' /> : '')
									}
								</span>
							)}
						</>
					)
					: (
						<img src={defaultInLynkLogo}
							alt='inLynk-logo' height='32' width='120'
						/>
					)}
			</div>
			<div className='flexMinWidthRow justifyEnd pointer'>
				<Tooltip title={language?.lang}>
					<button
						tabIndex={0}
						onKeyUp={(e) => { e.key === 'Enter' && handleOpen(); }}
						className='flexAutoRow alignCntr justifyCntr respdngLSM'
						onClick={handleOpen}
					>
						<IconButton aria-label='languageBtn'>
							<LanguageIcon className='nomrg' />
						</IconButton>
						<span className='headingSM'>{languageD?.label}</span>
						<ArrowDropDownIcon />
					</button>
				</Tooltip>
				<Modal
					open={open}
					onClose={handleClose}
					aria-labelledby='modal-modal-title'
					aria-describedby='modal-modal-description'
				>
					<Box sx={style}>
						<div className='flexRow alignCntr pdngXS'>
							<div className='flexMinWidthRow pdngHXS'>
								<Typography variant='h5' component='h5'>
									{language?.selectLanguage}
								</Typography>
							</div>
							<div className='flexAuto'>
								<IconButton onClick={handleClose}>
									<Close />
								</IconButton>
							</div>
						</div>
						<ul className=''>
							{Data.map((each, index) =>
							{
								const lastBtn = index === Data.length - 1 ? 'lastBtn' : '';

								return (
									<button
										className={`flexRow alignCntr justifyBtwn LangBtn respdngHMD ${lastBtn}`}
										onClick={() =>
										{
											langselect(each?.id);
										}}
										key={each?.id}
									>
										<span>{each.label}</span>
										{language === each?.id && <Done />}
									</button>
								);
							})}
						</ul>
					</Box>
				</Modal>
			</div>
		</div>

	);
};

export default LoginHeader;
